import { mockComponent } from 'bloko/common/setupMockComponents';

export default mockComponent('CustomSelectOption', null, {
    withChildren: true,
});
